import vue from 'vue'
import PortflioTable from './PortfolioTable.vue';
import axios from "axios";
import { symbolName } from 'typescript';

export default vue.extend({
name: 'AiAnalysis',
components: {
    PortflioTable
},
props:{        
    portfolio: Object,
    userInfo: Object,
},
methods: {        
    submit() {
        let symbol = $('#ai-analyze').val();

        if (symbol){

            let port = {
                id: this.portfolio.id,
                symbol: symbol
            }

            this.loadAiAnalysis(port);

            localStorage.setItem("symbol", symbol);
        }
    },

    async loadAiAnalysis(id){
        var url = '/api/portfolio/'+id.id+'/json?symbol='+id.symbol;
        const e = await axios.get(url);
        if (e.data.responseCode == 50){
            return;
        }
        this.items = e.data.payload.items;
        let label = $('#info-labe-ai-analyze');
        if(this.items.length > 0){
            this.isShow = false;
            await this.$nextTick();
            label.empty();
            this.isShow = true;
        }else{
            label.text('Symbol not found!');
        }
    }
},
data: () => {
    return {
        isShow: false,
        items: null
    }
},
created: function() {
    var savedSymbol = localStorage.getItem("symbol");

    if(savedSymbol){
        let port = {
            id: this.portfolio.id,
            symbol: savedSymbol
        }
        this.loadAiAnalysis(port);
    }
}
});